import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '../store/index'

Vue.use(VueRouter)

const routes = [
    {
        // 登录
        path: '/login',
        name: 'login',
        component: () => import('@/views/login/login.vue')
    },
    {
        path: '/',
        name: 'index',
        component: () => import('@/views/index/index.vue')
    },
    {
        //快速记账
        path: '/jizhang',
        name: 'jizhang',
        component: () => import('@/views/index/jizhang.vue')
    },
    {
        //订单管理
        path: '/order',
        name: 'order',
        component: () => import('@/views/index/order.vue')
    },
    {
        //客户管理
        path: '/customer',
        name: 'customer',
        component: () => import('@/views/index/customer.vue')
    },
    {
        //客户管理详情
        path: '/customer_details',
        name: 'customer_details',
        component: () => import('@/views/index/customer_details.vue')
    },
    {
        //批次管理
        path: '/pici',
        name: 'pici',
        component: () => import('@/views/index/pici.vue')
    },
    {
        //羊场钱包
        path: '/wallet',
        name: 'wallet',
        component: () => import('@/views/index/wallet.vue')
    },
    {
        // 注册
        path: '/register',
        name: 'register',
        component: () => import('@/views/login/register.vue')
    },
    {
        // 忘记密码
        path: '/forget',
        name: 'forget',
        component: () => import('@/views/login/forget.vue')
    },
    {
        // 账户信息
        path: '/userinfo',
        name: 'userinfo',
        component: () => import('@/views/index/userinfo.vue')
    },
    {
        // 我的收藏
        path: '/usersc',
        name: 'usersc',
        component: () => import('@/views/index/usersc.vue')
    },
    {
        // 修改密码
        path: '/userpassword',
        name: 'userpassword',
        component: () => import('@/views/index/userpassword.vue')
    },
    {
        //测试
        path: '/test',
        name: 'test',
        component: () => import('@/views/index/test.vue')
    },

]

const router = new VueRouter({
    routes,
    mode: 'history'
})

// router.beforeEach((to, from, next) => {
//     if (to.path == '/login') {
//         next()
//     }
//     if (store.state.token == null) {
//         next()
//     } else {
//         next({ path: '/login' })
//     }
//     next()
// })
export default router
